import { validationSchema } from "../form/ValidationSchema";

export default class Validation {
  static isRequired(name) {
    const schema = validationSchema.fields;
    const field = schema[name];

    if (!field) {
      return false;
    }

    const tests = field.describe().tests;

    if (tests.length > 0) {
      for (let i = 0; i < tests.length; i++) {
        if (tests[i].name === 'required') {
          return true;
        }
      }
    }

    return false;
  }
}
